import { RoleCode } from "../../utils/Constant";

interface Action {
	actionCode: string;
}

interface Permission {
	screenCode: string;
	actionList?: Action[];
}

export const permissionAndRoleCheck = (
	permissions: Permission[],
	activeView: string,
	action: string
): boolean => {
	const myPermissions =
		permissions && typeof permissions === "object" && Object.entries(permissions).length > 0
			? permissions?.find((el) => el.screenCode === activeView)
			: null;
	return myPermissions?.actionList?.some((el) => el.actionCode === action) || false;
};

export const isAdmin = (userRoleCode: string | null): boolean => {
	return userRoleCode === RoleCode.COMPANY_ADMIN;
};

export const checkViewPermission = (permissions: string[], activeView: string): boolean => {
	return permissions.includes(activeView);
};
